import React, { useState } from 'react'
import { isBrowser } from 'react-device-detect'

import useLongPress from '../../../utils/useLongPress'
import TemporaryPersonBadge from './TemporaryPersonBadge';
import { panToCaixa } from '../PissarraController';
import { applyTimeZone, getSubdomain } from '../../../utils/utils';
import { getCastellerShortName } from '../../../utils/castellerName';
import { hasAlturaMansFeature } from '../../../utils/colla-features';

const COLLA = getSubdomain();

const hasTambor = info =>
    !!parseInt(info?.music) && (parseInt(info?.casteller) !== 1 || COLLA === 'ganapies');

export const setPerfil = altura => {
    // Està 'undefined'
    if (altura === null) return "sense_altura";

    // Mesures/Perfils d'Arreplegats
    if (altura <= -10) return "Falca";
    else if (altura <= -3) return "Crossa";
    else if (altura <= 5) return "Baix";
    else if (altura <= 10) return "Lateral";
    else if (altura > 10) return "Rengla";

    return "sense_altura";
};

const getName = info =>
    (!!parseInt(info?.canalla) ? '👶 ' : '') +
    (hasTambor(info) ? '🥁 ' : '') +
    (!!parseInt(info?.lesionat) ? '🏥 ' : '') +
    getCastellerShortName(info)

function Casteller(props) {
    const { matched, json, altura, altura_mans, id, panzoom, selected, posicions, printed, setCastellerSelected, arribaTard, surtAviat, setHoveredUser, hoveredUser } = props;
    const displayName = props.displayName ? props.displayName : getName(props)

    // Get arrival and departure times from assistenciesEvent
    const assistenciaInfo = props.assistenciesEvent?.find(a => parseInt(a.id) === parseInt(id));
    const arrivalTime = assistenciaInfo?.['data-entrada'];
    const departureTime = assistenciaInfo?.['data-sortida'];

    // Format times if they exist
    const formattedArrival = arrivalTime ? applyTimeZone(arrivalTime).format('HH:mm') : null;
    const formattedDeparture = departureTime ? applyTimeZone(departureTime).format('HH:mm') : null;

    const [prevVal, setPrevVal] = useState(null)
    const isTemporary = Number(props.is_temporary ?? props.castellersInfo?.[id]?.is_temporary) === 1;

    const selectCasteller = () => {
        if (Number(id) < -1) return; // Local previews are not server identities.
        const prevCaixa = posicions.castellers?.[id]
        const prevCaixaInfo = json[prevCaixa]
        const isTronc = prevCaixaInfo?.tronc || prevCaixaInfo?.pilar !== undefined

        if (isTronc) {
            const confirmation = window.confirm(`Esteu segurs que voleu treure "${displayName}" del tronc?`);
            if (!confirmation) return;
        }

        setCastellerSelected(prev => prev != id ? id : -1);
    }

    const highlightCasteller = casteller_id => {
        // Prevent swapping castellers
        props.setCaixaSelected(-1);

        if (!(casteller_id in posicions.castellers)) return;
        const caixaToHighlight = posicions.castellers[casteller_id];

        // Set value when highlighting
        if (prevVal === null) setPrevVal([panzoom.getTransform().x, panzoom.getTransform().y])

        // Pan to caixa
        panToCaixa(caixaToHighlight, panzoom, isBrowser)
        // Highlight caixa
        document.getElementById(`caixa-${caixaToHighlight}`)?.classList.add('highlighted');
    };
    const unhighlight = () => {
        // Pan to previously set value in highlight
        if (prevVal !== null) {
            // Disable panback
            // panzoom.smoothMoveTo(prevVal[0], prevVal[1])
            setPrevVal(null);

            // Prevent swapping castellers
            props.setCastellerSelected(-1)
        }

        // Remove highlighted
        document.querySelector('.highlighted')?.classList.remove('highlighted');
    }

    const longPressEvent = useLongPress(
        () => highlightCasteller(id),
        () => unhighlight(),
        500
    );

    const isHovered = hoveredUser === id;

    return (
        <div
            id={`casteller-${id}`}
            onClick={() => selectCasteller()}
            onMouseEnter={() => setHoveredUser(id)}
            onMouseLeave={() => setHoveredUser(null)}
            {...longPressEvent}
            className={`casteller ${matched ? 'matched' : ''} ${surtAviat ? 'aviat' : ''} ${arribaTard ? 'tard' : ''} ${setPerfil(altura)} ${selected ? 'selected' : ''} ${printed ? 'noseleccionable' : ''} ${isHovered ? 'hovered' : ''}`}
        >
            <div className="nom">
                {displayName}
                {isTemporary && <TemporaryPersonBadge />}
                <div className="time-indicators">
                    { arribaTard && formattedArrival && <span className="time">🛬 {formattedArrival}</span> }
                    { surtAviat && formattedDeparture && <span className="time">🛫 {formattedDeparture}</span> }
                </div>
            </div>
            { altura !== null && <div className="altura">{altura}</div> }
            { hasAlturaMansFeature() && altura_mans !== null && altura_mans !== undefined &&
                <div className={`individual-display relative`} style={{ backgroundColor: '#FAAB78', fontSize: 12 }}>
                    {altura_mans}
                </div> 
            }
        </div>
    );
}

export default React.memo(Casteller, (props, newProps)=> {
    const oldSelComparison = props.castellerSelected === props.id;
    const newSelComparison = newProps.castellerSelected === newProps.id;

    const infoHasNotChanged = props.castellersInfo === newProps.castellersInfo;
    const printedHasNotChanged = props.printed === newProps.printed;
    const matchedHasNotChanged = props.matched === newProps.matched;
    const myPositionHasNotChanged =
        (props.id in props.posicions.castellers || props.id in newProps.posicions.castellers) ?
            (props.id in props.posicions.castellers === props.id in newProps.posicions.castellers)
            && (props.posicions.castellers[props.id] === newProps.posicions.castellers[props.id])
        :
            false

    // Do not re-render if...
    return oldSelComparison === newSelComparison && infoHasNotChanged && printedHasNotChanged && myPositionHasNotChanged && matchedHasNotChanged;
});
